import styled from 'styled-components';

const Image = styled.img`
  max-height: 240px;
  max-width: 100%;
  display: block;
`;

export default Image;
